import { getStatesUseCase } from '@/domain/use-cases/get-states.use-case';
import { Result } from '@/entities/Result';
import { StatesResponse } from '@/entities/State';

export const lookupStatesController = async (countryId?: string): Promise<Result<StatesResponse>> => {
	return getStatesUseCase(countryId);
};
